import axios from 'axios';
import { NotificationProgrammatic as Notify, ToastProgrammatic as Toast } from 'buefy'

let development = process.env.NODE_ENV !== 'production'

export const apiService = axios.create({
  headers: {
    'X-CSRFToken': document.getElementsByName('csrfmiddlewaretoken')[0].value
  },
  baseURL: process.env.BASE_URL_AXIOS
})


export const postHandler = async (endpoint, data, messages) => {

    const resources = {notify:Notify, toast:Toast}
    let msgData = {}
    try {
       
        const response = await apiService.post(endpoint, data);
        
        if (response.status === 201 || response.status === 200) {
           
            msgData = messages.success
            if (msgData){
                let resource = resources[msgData.resource]
                resource.open({
                    duration: 3000,
                    message: msgData.text ? msgData.text : "Your actions have been successfully performed.",
                    position: msgData.position ? msgData.position : "is-top-right",
                    type: msgData.type ? msgData.type : "is-success",
                    hasIcon: msgData.hasIcon ? msgData.hasIcon : false
                })
            }
            return response

        } else{
           
            msgData = messages.error
            if (msgData){
                let resource = resources[msgData.resource]
                resource.open({
                    duration: 3000,
                    message: msgData.text ? msgData.text : "Something went wrong, try again later...",
                    position: msgData.position ? msgData.position : "is-top-right",
                    type: msgData.type ? msgData.type : "is-danger",
                    hasIcon: msgData.hasIcon ? msgData.hasIcon : false
                })
            }
            return false
        }

    } catch{
        
        msgData = messages.error
        if (msgData){
            let resource = resources[msgData.resource]
            resource.open({
                duration: 3000,
                message: msgData.text ? msgData.text : "Something went wrong, try again later...",
                position: msgData.position ? msgData.position : "is-top-right",
                type: msgData.type ? msgData.type : "is-danger",
                hasIcon: msgData.hasIcon ? msgData.hasIcon : false
            })
        }
        return false
    }
}




export const getHandler = async (endpoint, messages) => {
    const resources = {notify:Notify, toast:Toast}
    let msgData = {}
    
    try{
        const response = await apiService.get(endpoint);
        
        if (response.status === 200 || response.status === 204) {
           
            msgData = messages.success
            if (msgData){
                let resource = resources[msgData.resource]
                resource.open({
                    duration: 3000,
                    message: msgData.text ? msgData.text : "Your actions have been successfully performed.",
                    position: msgData.position ? msgData.position : "is-top-right",
                    type: msgData.type ? msgData.type : "is-success",
                    hasIcon: msgData.hasIcon ? msgData.hasIcon : false
                })
            }
            
            return response.data;
            
        } else {
            
            msgData = messages.error
            if (msgData){
                let resource = resources[msgData.resource]
                resource.open({
                    duration: 3000,
                    message: msgData.text ? msgData.text : "Something went wrong, try again later...",
                    position: msgData.position ? msgData.position : "is-top-right",
                    type: msgData.type ? msgData.type : "is-danger",
                    hasIcon: msgData.hasIcon ? msgData.hasIcon : false
                })
            }
        }
    } catch{
        
        msgData = messages.error
        if (msgData){
            let resource = resources[msgData.resource]
            resource.open({
                duration: 3000,
                message: msgData.text ? msgData.text : "Something went wrong, try again later...",
                position: msgData.position ? msgData.position : "is-top-right",
                type: msgData.type ? msgData.type : "is-danger",
                hasIcon: msgData.hasIcon ? msgData.hasIcon : false
            })
        }
    }
}

export const deleteHandler = async (endpoint, messages) => {
    const resources = {notify:Notify, toast:Toast}
    let msgData = {}
    
    try{
        const response = await apiService.delete(endpoint);
        
        if (response.status === 200 || response.status === 204) {
           
            msgData = messages.success
            if (msgData){
                let resource = resources[msgData.resource]
                resource.open({
                    duration: 3000,
                    message: msgData.text ? msgData.text : "Your actions have been successfully performed.",
                    position: msgData.position ? msgData.position : "is-top-right",
                    type: msgData.type ? msgData.type : "is-success",
                    hasIcon: msgData.hasIcon ? msgData.hasIcon : false
                })
            }
            
            return response.data;
            
        } else {
            
            msgData = messages.error
            if (msgData){
                let resource = resources[msgData.resource]
                resource.open({
                    duration: 3000,
                    message: msgData.text ? msgData.text : "Something went wrong, try again later...",
                    position: msgData.position ? msgData.position : "is-top-right",
                    type: msgData.type ? msgData.type : "is-danger",
                    hasIcon: msgData.hasIcon ? msgData.hasIcon : false
                })
            }
        }
    } catch{
        
        msgData = messages.error
        if (msgData){
            let resource = resources[msgData.resource]
            resource.open({
                duration: 3000,
                message: msgData.text ? msgData.text : "Something went wrong, try again later...",
                position: msgData.position ? msgData.position : "is-top-right",
                type: msgData.type ? msgData.type : "is-danger",
                hasIcon: msgData.hasIcon ? msgData.hasIcon : false
            })
        }
    }
}

export const patchHandler = async (endpoint, data, messages) => {
    const resources = {notify:Notify, toast:Toast}
    let msgData = {}
  
    try {
        const response = await apiService.patch(endpoint, data);
        
        if (response.status === 204 || response.status === 200) {
            msgData = messages.success
            if (msgData){
                let resource = resources[msgData.resource]
                resource.open({
                    duration: 3000,
                    message: msgData.text ? msgData.text : "Your actions have been successfully performed.",
                    position: msgData.position ? msgData.position : "is-top-right",
                    type: msgData.type ? msgData.type : "is-success",
                    hasIcon: msgData.hasIcon ? msgData.hasIcon : false
                })
            }
            return response

        } else{
            msgData = messages.error
            if (msgData){
                let resource = resources[msgData.resource]
                resource.open({
                    duration: 3000,
                    message: msgData.text ? msgData.text : "Something went wrong, try again later...",
                    position: msgData.position ? msgData.position : "is-top-right",
                    type: msgData.type ? msgData.type : "is-danger",
                    hasIcon: msgData.hasIcon ? msgData.hasIcon : false
                })
            }
        }

    } catch{
        
        msgData = messages.error
        if (msgData){
            let resource = resources[msgData.resource]
            resource.open({
                duration: 3000,
                message: msgData.text ? msgData.text : "Something went wrong, try again later...",
                position: msgData.position ? msgData.position : "is-top-right",
                type: msgData.type ? msgData.type : "is-danger",
                hasIcon: msgData.hasIcon ? msgData.hasIcon : false
            })
        }
    }
}

export const debounce = (func, delay) => { 
    let debounceTimer 
    return function() { 
        const context = this
        const args = arguments 
            clearTimeout(debounceTimer) 
                debounceTimer 
            = setTimeout(() => func.apply(context, args), delay) 
    } 
}  